import { useEffect, useState } from 'react'
import autoSuggestionsdata from './Autosuggestionsdata'
import React from 'react'
import _ from 'lodash'
import CastUi from './CastUi'
import GetCastRoleNames from './GetCastRoleNames'

export default function Cast(props) {
  // props for this file from parent
  const {
    inputdata,
    sendinputdata,
    truevalue,
    modeUrl,
    active,
    handleActiveChange,
    editData,
    sendtruevalue,
    movieData,
    movieMode,
  } = props
  // state varaibles for this file
  const [casten, setcasten] = useState([])
  const [castenvalue, setcastenvalue] = useState('')
  const [castCharacterEn, setcastCharacterEn] = useState([])
  const [castCharacterEnvalue, setcastCharacterEnvalue] = useState('')
  const [CastTe, setCastTe] = useState([])
  const [CastTeValue, setCastTeValue] = useState('')
  const [castcharte, setcastcharte] = useState([])
  const [castCharacterTeValue, setcastCharacterTeValue] = useState('')
  const [finalcastname, setfinalcastname] = useState([])
  const [castarray, setcastarray] = useState([])
  const [searchTrue, setSearchTure] = useState(true)
  const [autoSuggestions, setAutoSuggestions] = useState([])
  const [editmode, seteditmode] = useState(true)

  const sendEditmode = data => {
    seteditmode(data)
  }

  const selectsuggestion = (_event, index) => {
    sendtruevalue('cast', true)
    // const regex = /Create [A-Za-z]+/i
    if (index === 0) {
      setSearchTure(false)
      setCastTeValue('')
    } else {
      const indexTemp = autoSuggestions
        ? autoSuggestions.personHits.findIndex(
            castElementobject => castElementobject.name_En === finalcastname[index].label,
          )
        : ''

      if (indexTemp > -1) {
        setcastenvalue(finalcastname[index].label)
        setCastTeValue(autoSuggestions ? autoSuggestions.personHits[indexTemp].name_Te : [])
        const castArrayTemp = [...castarray]
        const indexOfEnElement = castArrayTemp.findIndex(
          castElementobject =>
            castElementobject.personID === autoSuggestions.personHits[indexTemp].PK,
        )
        if (indexOfEnElement > -1) {
          castArrayTemp[indexOfEnElement].isAnonymous = false
        } else {
          const suggetion = { newPerson: true, ...autoSuggestions.personHits[indexTemp] }
          castArrayTemp.push(suggetion)
        }

        setcastarray(castArrayTemp)
        setAutoSuggestions([])
        setfinalcastname([])
      }
    }
  }

  const sendcastenvalue = data => {
    setcastenvalue(data)
  }

  const sendCastTeValue = data => {
    setCastTeValue(data)
  }

  const sendcastCharacterEn = data => {
    setcastCharacterEn(data)
  }

  const sendcastcharte = data => {
    setcastcharte(data)
  }

  const sendcasten = data => {
    setcasten(data)
  }

  const sendCastTe = data => {
    setCastTe(data)
  }

  const sendcastCharacterTeValue = data => {
    setcastCharacterTeValue(data)
  }

  const sendcastCharacterEnvalue = data => {
    setcastCharacterEnvalue(data)
  }

  const handlechangete = value => {
    setCastTeValue(value)
  }

  const handlechangecharacterte = value => {
    setcastCharacterTeValue(value)
  }

  const handlechange = value => {
    if (value) {
      setcastenvalue(value)
    } else {
      setSearchTure(true)
      handleChangeFilter('')
    }
  }

  const handlechangecharacter = value => {
    setcastCharacterEnvalue(value)
  }

  const handleChangeFilter = async value => {
    setcastenvalue(value)
    if (value.length >= 3) {
      const movieData = await autoSuggestionsdata(value)
      setAutoSuggestions(movieData)
      const finalname = movieData ? movieData.personHits.map(e => ({ label: e.name_En, personID: e.personID ? e.personID : e.PK, ...e })) : []
      finalname.unshift({ label: `Create ${value}` })
      setfinalcastname(finalname)
    }

    if (value === '') {
      setfinalcastname([])
    }
  }

  const castvalue2 = (CastTeValue, castenvalue) => {
    if (CastTeValue !== '') {
      return CastTeValue
    }

    return castenvalue ? '' : ''
  }

  const castcharvalue2 = (castCharacterTeValue, castCharacterEnvalue) => {
    if (castCharacterTeValue !== '') {
      return castCharacterTeValue
    }

    return castCharacterEnvalue ? '' : ''
  }

  // const SubmitCast = async () => {
  //   seteditmode(true)
  //   sendtruevalue('cast', true)
  //   const castenTemp = [...casten]
  //   castenTemp.push(castenvalue)
  //   setcasten(castenTemp)
  //   const castCharacterEnTemp = [...castCharacterEn]
  //   castCharacterEnTemp.push(castCharacterEnvalue)
  //   setcastCharacterEn(castCharacterEnTemp)
  //   let castas2 = []
  //   setcastCharacterEnvalue('')
  //   setcastenvalue('')
  //   const CastTeTemp = [...CastTe]
  //   const CastTeValue2 = castvalue2(CastTeValue, castenvalue)
  //   CastTeTemp.push(CastTeValue2)
  //   setCastTe(CastTeTemp)
  //   const castcharteTemp = [...castcharte]
  //   const castCharacterEnvalue2 = castcharvalue2(castCharacterTeValue, castCharacterEnvalue)
  //   castcharteTemp.push(castCharacterEnvalue2)
  //   setcastcharte(castcharteTemp)
  //   const castasteTemp = CastTeTemp.map(
  //     (e, index) =>
  //       `${e ? e : ''} ${castcharteTemp[index] ? 'గా' : ''} ${
  //         castcharteTemp[index] ? castcharteTemp[index] : ''
  //       }`,
  //   )

  //   const data = {
  //     castenTemp,
  //     castarray,
  //     CastTeTemp,
  //     castCharacterEnTemp,
  //     castcharteTemp,
  //     castas2,
  //   }

  //   castas2 = await GetCastRoleNames(data)
  //   const inputDataTemp = { ...inputdata }
  //   const castas3 = _.uniqBy(castas2, 'name_En')
  //   inputDataTemp.Moviecast = castas3
  //   inputDataTemp.Moviecastte = castasteTemp
  //   inputDataTemp.CastTe = castcharte
  //   sendinputdata(inputDataTemp)
  //   setcastCharacterTeValue('')
  //   setCastTeValue('')
  //   setfinalcastname([])
  //   setSearchTure(true)
  // }
  const SubmitCast = async () => {
    seteditmode(true)
    sendtruevalue('cast', true)

    const updatedCasten = [...casten, castenvalue]
    setcasten(updatedCasten)

    const updatedCastCharacterEn = [...castCharacterEn, castCharacterEnvalue]
    setcastCharacterEn(updatedCastCharacterEn)

    setcastCharacterEnvalue('')
    setcastenvalue('')

    const updatedCastTe = [...CastTe, castvalue2(CastTeValue, castenvalue)]
    setCastTe(updatedCastTe)

    const updatedCastCharte = [...castcharte, castcharvalue2(castCharacterTeValue, castCharacterEnvalue)]
    setcastcharte(updatedCastCharte)

    const updatedCastaste = updatedCastTe.map((e, index) => `${e ? e : ''} ${updatedCastCharte[index] ? 'గా' : ''} ${updatedCastCharte[index] ? updatedCastCharte[index] : ''}`)

    const data = {
      castenTemp: updatedCasten,
      castarray,
      CastTeTemp: updatedCastTe,
      castCharacterEnTemp: updatedCastCharacterEn,
      castcharteTemp: updatedCastCharte,
      updatedCastRoles: [],
    }

    const updatedCastRoles = await GetCastRoleNames(data)
    const uniqueCastas = _.uniqBy(updatedCastRoles, 'name_En')

    const updatedInputData = { ...inputdata }
    updatedInputData.Moviecast = uniqueCastas
    updatedInputData.Moviecastte = updatedCastaste
    updatedInputData.CastTe = updatedCastCharte

    sendinputdata(updatedInputData)
    setcastCharacterTeValue('')
    setCastTeValue('')
    setfinalcastname([])
    setSearchTure(true)
  }

  useEffect(() => {
    // CastFromWiki([])
    const castenFromEdit = [...casten]
    const castteFromEdit = [...CastTe]
    const castCharacterEnFromEdit = [...castCharacterEn]
    const castCharteFromEdit = [...castcharte]
    const castenTemp = inputdata.cast ? inputdata.cast.map(e => e.name_En) : ''
    const castCharacterEnTemp = inputdata.cast
      ? inputdata.cast.map(e => (e.roleName_En ? e.roleName_En.split('as ') : ''))
      : []
    const castCharacterEn2 = castCharacterEnTemp.map(e => {
      if (e.length >= 2) {
        return e[1]
      }

      return e[0]
    })
    const CastTeTemp = inputdata.cast ? inputdata.cast.map(e => e.name_Te) : []
    const castCharte = inputdata.cast
      ? inputdata.cast.map(e => {
          if (e.name_En) {
            return ''
          }

          return ''
        })
      : []

    // setcastarray(movieData)
    castenFromEdit.push(...castenTemp)
    castteFromEdit.push(...CastTeTemp)
    castCharacterEnFromEdit.push(...castCharacterEn2)
    castCharteFromEdit.push(...castCharte)
    setcasten(castenFromEdit)
    setCastTe(castteFromEdit)
    setcastCharacterEn(castCharacterEnFromEdit)
    setcastcharte(castCharteFromEdit)
  }, [inputdata.cast])
  useEffect(() => {
    if (movieMode === 'edit') {
      const castenTemp = movieData ? movieData.map(e => e.name_En) : ''
      const castCharacterEnTemp = movieData
        ? movieData.map(e => (e.roleName_En ? e.roleName_En.split('as ') : ''))
        : []
      const castCharacterEn2 = castCharacterEnTemp.map(e => {
        if (e.length >= 2) {
          return e[1]
        }

        return e[0]
      })
      const CastTeTemp = movieData ? movieData.map(e => e.name_Te) : []
      const castcharteTemp = inputdata.Moviecastte
        ? inputdata.Moviecastte.map(e => e.split('గా'))
        : []
      const castcharte2 = castcharteTemp.map((e, index) => {
        if (e.length >= 2) {
          if (e[1] === null) {
            return castCharacterEn2[index] ? '' : ''
          }

          return e[1].trimStart()
        }

        return castCharacterEn2[index] ? '' : ''
      })

      setcastarray(movieData ? movieData : [])
      setcasten(castenTemp)
      setCastTe(CastTeTemp)
      setcastCharacterEn(castCharacterEn2)

      setcastcharte(castcharte2)
    } else if (movieMode === 'create') {
      setcastarray(movieData ? movieData : [])
    }
  }, [movieData, movieMode])
  return (
    <CastUi
      truevalue={truevalue}
      sendtruevalue={sendtruevalue}
      sendEditmode={sendEditmode}
      castas={inputdata.Moviecast}
      sendcasten={sendcasten}
      editmode={editmode}
      sendCastTe={sendCastTe}
      castaste={inputdata.Moviecastte}
      sendinputdata={sendinputdata}
      sendcastCharacterTeValue={sendcastCharacterTeValue}
      sendcastCharacterEnvalue={sendcastCharacterEnvalue}
      inputdata={inputdata}
      casten={casten}
      CastTe={CastTe}
      castCharacterEn={castCharacterEn}
      castcharte={castcharte}
      sendcastCharacterEn={sendcastCharacterEn}
      sendcastcharte={sendcastcharte}
      sendcastenvalue={sendcastenvalue}
      sendCastTeValue={sendCastTeValue}
      editData={editData}
      modeUrl={modeUrl}
      active={active}
      searchTrue={searchTrue}
      handleChangeFilter={handleChangeFilter}
      castenvalue={castenvalue}
      finalcastname={finalcastname}
      handlechangete={handlechangete}
      handlechange={handlechange}
      handleActiveChange={handleActiveChange}
      handlechangecharacterte={handlechangecharacterte}
      castCharacterTeValue={castCharacterTeValue}
      handlechangecharacter={handlechangecharacter}
      castCharacterEnvalue={castCharacterEnvalue}
      CastTeValue={CastTeValue}
      selectsuggestion={selectsuggestion}
      SubmitCast={SubmitCast}
    />
  )
}
